import { render } from "./Plugin.vue?vue&type=template&id=827893b6"
import script from "./Plugin.vue?vue&type=script&lang=js"
export * from "./Plugin.vue?vue&type=script&lang=js"
script.render = render

export default script